import React from 'react';
import { connect } from 'react-redux';
import { VISUALIZER_SHAPE } from '../../Preview/PreviewDisplayConstants';
import { List, Collapse } from '@mui/material';
import VisualizerSpectrumListItem from './inputs/VisualizerSpectrumListItem';
import VisualizerShakeListItem from './inputs/VisualizerShakeListItem';
import VisualizerWaveDelayListItem from './inputs/VisualizerWaveDelayListItem';
import VisualizerBounceListItem from './inputs/VisualizerBounceListItem';
import VisualizerSpinListItem from './inputs/spin/VisualizerSpinListItem';
import VisualizerDriftListItem from './inputs/drift/VisualizerDriftListItem';

class VisualizerMotionEditor extends React.Component {
    render() {
        const { visualizerShape, driftEnabled } = this.props;
        const shapeIsCircle = visualizerShape === VISUALIZER_SHAPE.CIRCLE;

        return (
            <>
                {/* Render a list item for wave type */}
                <VisualizerSpectrumListItem />

                {/* Render a list item for wave delay */}
                <VisualizerWaveDelayListItem />

                <VisualizerDriftListItem />

                {/* Hide these controls when drift is enabled */}
                <Collapse in={!driftEnabled} timeout="auto" unmountOnExit>
                    <List dense disablePadding>
                        {/* Render a list item for shake/rumble amount */}
                        <VisualizerShakeListItem />

                        {/* Render a list item for bounce value in the case of circle visualizer */}
                        {shapeIsCircle && <VisualizerBounceListItem />}

                        <VisualizerSpinListItem />
                    </List>
                </Collapse>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    const visualizer = state.createPreview.present.videoSettings.visualizer;
    return { 
        visualizerShape: visualizer.shape,
        driftEnabled: visualizer.drift.enabled
    };
}

export default connect(mapStateToProps, {})(VisualizerMotionEditor);